import getPatientState from 'utils/print/getPatientState';

const getInsuranceInsuredsState = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  return getPatientState(otherProps);
};

export default getInsuranceInsuredsState;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceInsuredsState.js